import { CallToAction } from "@themes/pollinator/ui/CallToAction";

export type Phase = "pre-enrollment" | "enrollment";

export type Props = {
  daysRemaining: number;
  phase?: Phase;
  /** When provided, renders a "View outreach materials" button */
  onViewOutreach?: () => void;
};

const copy: Record<
  Phase,
  { title: (days: number) => string; description: string }
> = {
  "pre-enrollment": {
    title: () => "Enrollment Opens March 2",
    description:
      "Enrollment will open on March 2, which is a great time to send your alumni an email about this opportunity. This year we’re also opening up Pollinator to your staff & leadership, so that more great people from your org can get matched in a curated cohort of aligned professionals.",
  },
  enrollment: {
    title: (days) => `${days} Days Left in Enrollment`,
    description:
      "Participants have until April 13 to enroll in Pollinator's May cycle. Please continue reminding your alumni about this opportunity using email, social media, newsletters, print, and/or direct communications.",
  },
};

export function TrackingCallToAction({
  daysRemaining,
  phase = "enrollment",
  onViewOutreach,
}: Props) {
  if (daysRemaining <= 0) return null;

  const { title, description } = copy[phase];

  return (
    <CallToAction
      title={title(daysRemaining)}
      description={description}
      theme="light"
      variant="portal"
      {...(onViewOutreach && {
        primaryButtonText: "View outreach materials",
        onPrimaryClick: onViewOutreach,
      })}
    />
  );
}

export default TrackingCallToAction;
